require('./fox/index.js');
require('./fox/tab.js');
require('./fox/validator.js');
require('./fox/busca-cep.js');
//require('./fox/qz-tray.js');

window.sidebarCollapse = function () {
    var visible = $('#sidebar').is(":visible");
    if (visible) {
        $('#sidebar').hide('fast');
    } else {
        $('#sidebar').show('fast');
    }
};

window.showFocus = function (showId, focusId = null, hideId = null, speed = 400) {
    $('#' + showId).show(speed);
    if (hideId !== null) {
        $('#' + hideId).hide(speed);
    }
    focusId = (focusId === null) ? showId : focusId;
    setTimeout(function () {
        $('#' + focusId).focus();
    }, 500);
};

window.show = function (elId, speed = 'slow') {
    $('#' + elId).show(speed);
};

window.hide = function (elId, speed = 'slow') {
    $('#' + elId).hide(speed);
};

window.focus = function (elId) {
    $('#' + elId).focus();
};

window.disable = function (el) {
    $('#' + el).prop('disabled', true);
};

window.enable = function (el) {
    $('#' + el).prop('disabled', false);
};

window.toNumber = function (numberText, places = 2) {
    var number = numberText.toString().replace(/,/, '.');
    return Number(number).toFixed(places);
};

window.message = function (css, message) {
    $.ajax({
        url: "/ajax/set-message",
        type: "get",
        data: {
            class: css,
            message: message
        },
        success: function (data) {
            unsetMessage();
        },
        error: function (data) {
            console.log('Message Error', data);
            return false;
        }
    });
};

window.ajaxSetMessage = function (css, message, redirect = '', script = 'modalRedirect()', focus = null) {
    $.ajax({
        url: "/ajax/set-message",
        type: "get",
        data: {
            class: css,
            message: message
        },
        success: function (data) {
            if (focus) {
                setTimeout(function () {
                    $('#' + focus).focus();
                }, 500);
            }
            $('#modalMsgContainer').html(data);
            $('#modalRedirectContainer').val(redirect);
            $('#modalExecContainer').val(script);
            $("#msgModal").modal("show");
            $('#btn-message').focus();
            unsetMessage();
        },
        error: function (data) {
            console.log('ajaxSetMessageError', data);
            return false;
        }
    });
};

window.ajaxSetError = function (error, message = null) {
    let msg = message ? message : 'Houve um erro ao tentar executar o serviço! Verifique os detalhes no log desta página.';
    ajaxSetMessage('error', msg);
    console.log(error);
};

window.unsetMessage = function () {
    $.ajax({
        url: "/ajax/unset-message"
    });
};

window.alertResolve = function (alertId, action = false) {
    $.ajax({
        url: "/ajax/alert-resolve",
        type: "get",
        data: {
            alertId: alertId,
        },
        success: function () {
            if (action) {
                $.ajax({
                    url: action,
                    type: "get",
                    data: {},
                    success: function () {
                        $('#alert-' + alertId).hide('slow');
                        window.location.reload();
                    }
                });
            } else {
                $('#alert-' + alertId).hide('slow');
            }
        }
    });
};

$(document).on('select2:open', () => {
    setTimeout(() => document.querySelector('.select2-search__field').focus(), 200);
});
